import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import TopNavigation from '../../components/TopNavigation';
import ProductHeroSection from './components/ProductHeroSection';
import IndustriesLinkSection from './components/IndustriesLinkSection';
import HowSleeveWorksSection from './components/HowSleeveWorksSection';
import DeveloperExperienceSection from './components/DeveloperExperienceSection';
import CICDIntegrationSection from './components/CICDIntegrationSection';
import ConsistentEnvironmentsSection from './components/ConsistentEnvironmentsSection';
import InteroperabilityLayerSection from './components/InteroperabilityLayerSection';
import ProductCTASection from './components/ProductCTASection';
import Footer from '../../components/Footer';

const Product = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Product - Sleeve Orchestration Platform</title>
        <meta
          name="description"
          content="Sleeve is an intelligent orchestration framework that deploys and coordinates agents, tools, and humans across the cloud-edge continuum."
        />
        <meta name="keywords" content="orchestration platform, distributed systems, agent coordination, workflow engine, infrastructure control" />
        <meta property="og:title" content="Product - Sleeve Orchestration Platform" />
        <meta property="og:description" content="Unified Agent Orchestration for Industrial Systems" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <TopNavigation />
        
        <main className="content-area">
          <ProductHeroSection />
          <IndustriesLinkSection />
          <HowSleeveWorksSection />
          <DeveloperExperienceSection />
          <CICDIntegrationSection />
          <ConsistentEnvironmentsSection />
          <InteroperabilityLayerSection />
          <ProductCTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Product;